import React from "react";
import "../style/WorkExperience.css";

const workExperienceData = [
  {
    company: "Alphabet Inc.",
    logo: "https://www.freepnglogos.com/uploads/google-logo-png/google-logo-png-webinar-optimizing-for-success-google-business-webinar-13.png",
    position: "Software Engineering Intern",
    date: "May 2022 - Sep 2022",
    description: "Improved search model by 4% across main objectives (topicality, appeal, visual quality), impacting 10 million queries daily. \
        Designed and coded an algorithm to score image simplicity using color theory, 3D calculus, lightness, and image complexity. \
        Brainstormed new features for implementation through multiple iterations of A/B testing to correct flaws in model. \
        Conducted user preference research and competitor analysis to find new search signal ideas. Showed cross-functional \
        impact by filing bug tickets outside of project scope and discussed potential solutions with owners",
    techStack: ["C++", "Python"]
  },
  {
    company: "Cisco Systems",
    logo: "https://www.citypng.com/public/uploads/preview/cisco-square-blue-logo-icon-png-11663428158zl4zyn0h7j.png",
    position: "Software Engineering Intern",
    date: "Jan 2021 - Jun 2021",
    description: "Maintained and remodeled the command processing flow of the team's organizational chatbot by finishing 60+ Jira tickets. \
        Leveraged Jenkins and Kibana to discover system weaknesses by analyzing logs and performance—filing 30+ Jira tickets \
        Created an incident management dashboard for incidents stored in ServiceNow by building a website in Javascript and Pug \
        Streamlined process of recording incident data, and automated testing software using Selenium and its Standalone server",
    techStack: ["Python"]
  },
  {
    company: "Acertas Anlaytics",
    logo: "https://res.cloudinary.com/crunchbase-production/image/upload/c_lpad,h_170,w_170,f_auto,b_white,q_auto:eco,dpr_1/xstlypmrms4dhlebrwf9",
    position: "Software Engineering Intern",
    date: "May 2021 - Aug 2021",
    description: "Visualized data and prediction performance via confusion matrices, graphs, and plots with Pandas, Seaborn, and Matplotlib. \
    Trained time series forecasting LightGBM regression models with parameter hypertuning and cross validation. \
    Reorganized and cleaned big datasets (1,000,000+ entries) in PostgresSQL and MongoDB in Python.",
    techStack: ["Python"]
  },
  // add more work experience data objects here
];

const classesData = [
    ["Discrete Mathematics", "https://www1.cmc.edu/pages/faculty/SCannon/teaching.html"],
    ["Computer Science Theory", "https://www.cs.columbia.edu/~tal/3261/fall22/index.html"],
    ["Natural Language Processing", "https://www.cs.columbia.edu/~zhouyu/"],
    ["Computer Vision", "https://fpcv.cs.columbia.edu/"],
    ["Computer Systems", "http://www.cs.columbia.edu/~danr/3827/"],
    ["Deep Learning", "https://mice.cs.columbia.edu/c/d.php?d=255&"],
    ["Advanced Data Structures", "https://hmc-cs70-spring2020.github.io/"],
    ["Machine Learning", "https://www.cs.columbia.edu/~verma/classes/ml/index.html"],
    ["Advanced Programming in C", "http://www.cs.columbia.edu/~jae/3157/"],
    ["Artificial Intelligence: Algorithms", "https://bulletin.columbia.edu/search/?P=COMS%20W4701"],
    ["Database Systems", "http://www.columbia.edu/cu/bulletin/uwb/#/cu/bulletin/uwb/subj/COMS/W4111-20222-001"],
];

const WorkExperience = () => {
  return (
    <div className="work-experience-container">
      <h1>Work Experience</h1>
      {workExperienceData.map((item) => (
        <div className="work-experience-item" key={item.company}>
          <div className="company-logo">
            <img src={item.logo} alt={item.company} />
          </div>
          <div className="company-info">
            <h2>{item.company}</h2>
            <h3>{item.position}</h3>
            <p>{item.date}</p>
            <p>{item.description}</p>
            <div className="tech-stack">
              {item.techStack.map((tech) => (
                <span key={tech}>{tech}</span>
              ))}
            </div>
          </div>
        </div>
      ))}
      <div className="classes-container">
        <h2>Classes Taken</h2>
        <ul>
          {classesData.map((c, d) => (
            <li key={classesData[d][0]}>
                <a href={classesData[d][1]}> {classesData[d][0]} </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default WorkExperience;